import { render, staticRenderFns } from "./AlertasPantalla.vue?vue&type=template&id=6408424c&"
import script from "./AlertasPantalla.vue?vue&type=script&lang=ts&"
export * from "./AlertasPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports